import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'otw-terms-of-conditions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-of-conditions.component.html',
  styles: ``
})
export class TermsOfConditionsComponent {

}
